export class SheetFileType {
    sheetFileTypeId:number;
    sheetFileTypeName: string;
}